<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex">
      <h4 class="page-title">
        <i class="fa fa-clipboard"></i>
        Notice
      </h4>
      <ul class="breadcrumbs ml-auto">
        <li class="nav-home mr-1">
          <a href="#">
            <i class="fas fa-home text-muted"></i>
          </a>
        </li>
        <li class="nav-item">
          <a class="font_15" href="#">Board</a>
        </li>
        <li class="separator">
          <i class="flaticon-right-arrow"></i>
        </li>
        <li class="nav-item">
          <a class="font_15 font-weight-bold" href="#">Notice</a>
        </li>
      </ul>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!-- detail search start -->
    <b-card v-show="so.adv">
      <b-row>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_noticed_at">Noticed_at</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 d-flex align-self-center">
          <b-form-group>
            <b-button class="md-2 ml-2" size="sm" variant="outline-primary" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1w')">-1W</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('-1m')">-1M</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('w')">1W</b-button>
            <b-button class="md-2" size="sm" variant="primary" @click="set_sd('m')">1M</b-button>
            <b-form inline class="mt-2">
              <date-picker @change="refresh" v-model="so.opt.created_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              ~
              <date-picker @change="refresh" v-model="so.opt.created_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
            </b-form>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="opt_type">Solution</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <!-- <v-select label="text" v-model="so.opt['type']" :options="codes.BOARD_TYPE" @change="$refs._list.refresh()"></v-select> -->
            <select class="form-control" v-model="type" @change="$refs._list.refresh()">
              <option disabled value="">Please select solution</option>
              <option value="wfdetect">WFDetector : Detect and respond to forgery of web pagess</option>
              <option value="wmds">WMDS : Web Malware Detection System</option>
              <option value="wsfinder">WSFinder : WeShell Finder</option>
              <option value="webcastle">WEBCastle : Web Firewall</option>
              <option value="etc">Etc</option>
              <option value="release">Release</option>
            </select>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 cold-md-12 d-flex align-self-center mb-3" v-if="!user">
          <label class="col-form-label" for="opt_title_notice">Title</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center" v-if="!user">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="opt_title_notice" v-model="so.opt['title']"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center mb-3">
          <label class="col-form-label" for="ph_content_notice">Content</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center">
          <b-form-group>
            <b-form-input @keydown.enter="refresh" type="text" id="ph_content_notice" v-model="so.opt['content']"></b-form-input>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="col-xl-2 col-md-12 d-flex align-self-center">
          <label class="col-form-label" for="ph_search_opt_type">Match Type</label>
        </b-col>
        <b-col class="col-xl-4 col-md-12 align-self-center mt-4">
          <b-form-group>
            <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
              <b-form-radio value="and">Match all</b-form-radio>
              <b-form-radio value="or">Match at least one</b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="float-right mt-3">
        <b-form-group>
          <b-button size="sm" variant="add" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-row>
    </b-card>
    <!-- detail search end -->
    <div class="d-flex flex-wrap align-items-center">
      <b-col sm="2">
      </b-col>
      <b-col class="md-10 d-flex flex-wrap align-items-center">
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mr-2 mb7 mt-2">
            <button class="btn btn-icon mr-1" style="border-color: #e4e7ea;" @click="refresh()">
              <i class="fas fa-sync-alt"></i>
            </button>
            <button class="btn btn-icon mr-1" style="border-color: #e4e7ea;" @click="reset()">
              <i class="fas fa-times"></i>
            </button>
          </div>
          <div class="mr-2 mb7">
            <select class="form-control" name="sel1" id="sel1" :disabled="so.adv" :text="so.skt || 'Search'" v-model="so.sk" @change="sv_reset">
              <option value="">Search</option>
              <option v-if="!user" value="type">Solution</option>
              <option value="title">Title</option>
            </select>
          </div>
          <div class="mb7 mr-2">
            <select class="form-control" v-model="so.sv" v-if="so.sk == 'type'" @change="refresh">
              <option disabled value="">Please select solution</option>
              <option value="wfdetect">WFDetector : Detect and respond to forgery of web pagess</option>
              <option value="wmds">WMDS : Web Malware Detection System</option>
              <option value="wsfinder">WSFinder : WeShell Finder</option>
              <option value="webcastle">WEBCastle : Web Firewall</option>
              <option value="etc">Etc</option>
              <option value="release">Release</option>
            </select>
          </div>
          <div class="mr-2 mb7">
            <input type="text" class="form-control col-xl-12" name="input" id="input" :disabled="so.adv" v-if="so.sk != 'type'"  v-model="so.sv" @keyup.enter="refresh()">
          </div>
          <div class="mb7">
            <button class="btn btn-icon1 mr-1" @click="refresh()">
              <i class="fas fa-search"></i>
            </button>
            <!-- <button class="btn btn-icon2" @click="search_opt">
              <i class="fas fa-search-plus" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i>
            </button> -->
          </div>
        </b-input-group>
        <br>
        <b-input-group size="sm">
          <div class="mr-auto mb7"></div>
          <div class="mt-2">
            <b-checkbox @change="refresh" class="ml-3 mt-1" v-model="hide_del">Hide deleted</b-checkbox>
          </div>
          <div class="mb7 mr-2 mt-2">
            <button type="button" class="btn btn-sm btn-addition" tabindex="4" @click="$router.push({ name: 'board_notice', params: { id : 'add' } })">
              New Registration
            </button>
          </div>
          <div class="mb7">
            <select class="form-control" v-model="so.perPage" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Show count : Default 15</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </div>
        </b-input-group>
      </b-col>
    </div>
    <div class="d-flex flex-wrap align-items-center">
      <div class="mr-auto mb7">
        <b-badge class="mx-2" :variant="color[index % color.length]" v-for="(item, index) in _summary" :key="item.app_id">
          {{item.type.toUpperCase()}} : {{item.count | number}}
        </b-badge>
      </div>
    </div>
    <!--//-------------------------------------------------------------------------검색조건-->
    <!--//-------------------------------------------------------------------------리스트출력-->
    <div class="reg_card">
      <div class="reg_card_body">
        <div class="table-responsive">
          <b-table class="table table_add table-striped" hover striped responsive="sm" ref="_list" show-empty empty-text="not found"
            :items="load" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" @row-clicked="goDetail" style="cursor:pointer;">
            <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
            <template slot="created_at" slot-scope="row">{{row.item.created_at | date}}</template>
            <template slot="type" slot-scope="row">
              <del v-if="row.item.is_del">{{row.item.type.toLowerCase()}}</del>
              <span v-else>{{row.item.type.toLowerCase()}}</span>
            </template>
            <template slot="title" slot-scope="row">
              <del v-if="row.item.is_del">{{row.item.title}}</del>
              <span v-else>
                {{row.item.title}}
              </span>
            </template>
            <template slot="func" slot-scope="row">
              <b-btn @click="detail(row.item)" size="sm" class="btn btn-sm btn-insert" tabindex="4">More</b-btn>
            </template>
          </b-table>
        </div>
      </div>
    </div>
    <!--//-------------------------------------------------------------------------리스트출력-->
    <!--//-------------------------------------------------------------------------Pagination-->
    <div class="mt30">
        <b-pagination class="pagination justify-content-center" size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" :limit="10" prev-text="<" next-text=">"  />
    </div>
    <!--//-------------------------------------------------------------------------Pagination-->
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
  </script>